/* eslint
    new-cap: ["warn", { "capIsNew": false }],
    block-scoped-var: "warn",
    no-redeclare: "warn",
    consistent-return: "warn",
    @typescript-eslint/no-shadow: "warn",
    no-unused-expressions: "warn",
    @typescript-eslint/no-use-before-define: "warn"
*/

import { getElement, globalEvent } from '@shared/easyfy.core';
import { invoke } from '@shared/easyfy.decorators';
import EasyfyToaster, { MessageSeverity } from '@shared/easyfy.toaster';
import { addCss, hasClass, parseToBoolean, removeCss } from '@shared/easyfy.utils';
import basket from '@webModules/basket';
import PrescriptionModal, { ModalType } from '@webModules/prescriptionModal';
import '@webModules/scrollState';
import prescriptionService from '@webServices/prescription.service';

namespace Easyfy.Web.Pages.Prescription {
  enum State {
    Processing = 'processing',
    Success = 'success',
    Fail = 'fail'
  }

  @invoke
  class MyPrescriptions {

    static Instance: MyPrescriptions;

    static proxyListElement: HTMLElement;

    static prescriptionListSortersElement: HTMLElement;

    static prescriptionListElement: HTMLElement;

    static subventionsElement: HTMLElement;

    static expiredPrescriptionsElement: HTMLElement;

    static prescriptionDetailsModal: HTMLElement;

    static prescriptionDetailsContainer: HTMLElement;

    static subventionElement: HTMLElement;

    static messageArea: HTMLElement;

    static loaderString = '<div class="loader m-t-medium" role="status" aria-live="polite" aria-label="Laddar"></div>';

    static buttonLoaderString =
      '<div class="loader loader-small loader-white" role="status" aria-live="polite" aria-label="Laddar"></div>';

    private scrollState: number = 0;

    private selectedProxy: string | null;

    private modal: PrescriptionModal;

    private toaster: EasyfyToaster;

    static lastOrdinationId: string | null = null;

    constructor() {
      MyPrescriptions.Instance = this;
      this.modal = new PrescriptionModal();
      this.toaster = new EasyfyToaster(null);
    }

    onInit() {
      globalEvent({
        type: 'click',
        event: {
          action: 'toggle-proxy-list',
          callback: MyPrescriptions.ChangeProxySelectorState
        }
      });


      globalEvent({
        type: 'change',
        event: {
          action: 'select-proxy-person',
          callback: MyPrescriptions.SelectProxyPerson
        }
      });

      globalEvent({
        type: 'click',
        event: {
          action: 'change-selected-proxy',
          callback: MyPrescriptions.ChangeSelectedProxy
        }
      });

      globalEvent({
        type: 'click keydown',
        event: {
          action: 'prescription-details',
          callback: MyPrescriptions.OpenPrescriptionDetails
        }
      });

      globalEvent({
        type: 'click keydown',
        event: {
          action: 'animal-prescription-details',
          callback: MyPrescriptions.OpenAnimalPrescriptionDetails
        }
      });

      globalEvent({
        type: 'click',
        event: {
          action: 'close-prescription-details',
          callback: MyPrescriptions.ClosePrescriptionDetails
        }
      });
      globalEvent({
        type: 'click',
        event: {
          action: 'prescription-buy',
          callback: MyPrescriptions.PrescriptionBuy
        }
      });
      globalEvent({
        type: 'click',
        event: {
          action: 'toggle-prescription-info',
          callback: MyPrescriptions.TogglePrescriptionInfo
        }
      });
      globalEvent({
        type: 'click',
        event: {
          action: 'add-child-modal',
          callback: MyPrescriptions.GetChildModal
        }
      });
      globalEvent({
        type: 'click',
        event: {
          action: 'animal-consent-modal',
          callback: MyPrescriptions.GetAnimalConsentModal
        }
      });
      globalEvent({
        type: 'click',
        event: {
          action: 'close-message',
          callback: MyPrescriptions.CloseMessage
        }
      });

      globalEvent({
        type: 'click',
        event: {
          action: 'get-fass-modal',
          callback: MyPrescriptions.GetFassModal
        }
      });

      globalEvent({
        type: 'click',
        event: {
          action: 'open-exchange-modal',
          callback: MyPrescriptions.GetExchangeInfoModal
        }
      });

      document.addEventListener('change-sort-option-prescription', (e) => {
        MyPrescriptions.ChangeSort(e)
      });

      window.addEventListener('popstate', (_e: PopStateEvent) => {
        MyPrescriptions.CheckBrowserNavigation();
      });

      (getElement<HTMLElement>('html')).style.scrollBehavior = 'auto';

      MyPrescriptions.proxyListElement = getElement<HTMLElement>('[data-container="proxy-list"]');
      document.addEventListener('click', (e) => {
        MyPrescriptions.CloseProxyList(e);
      });
      
      document.addEventListener('deletePrescriptionRow', MyPrescriptions.ReloadPrescriptions);
      
      MyPrescriptions.prescriptionListElement = getElement<HTMLElement>('[data-container="prescription-list"]');
      MyPrescriptions.prescriptionListSortersElement = getElement<HTMLElement>('[data-container="prescription-list-sorters"]');
      MyPrescriptions.subventionsElement = getElement<HTMLElement>('[data-container="prescription-list-subventions"]');
      MyPrescriptions.expiredPrescriptionsElement = getElement<HTMLElement>('[data-container="expired-prescriptions"]');
      MyPrescriptions.prescriptionDetailsModal = getElement<HTMLElement>('[data-container="prescription-details-modal"]');
      MyPrescriptions.prescriptionDetailsContainer = getElement<HTMLElement>('[data-container="prescription-details-container"]');
      MyPrescriptions.subventionElement = getElement<HTMLElement>('[data-container="prescription-list-subventions"]');
      MyPrescriptions.messageArea = getElement<HTMLElement>('[data-container="message-container"]');

      MyPrescriptions.CheckForPreSelectedUserInRequest();

      window.dispatchEvent(new Event('popstate'));
    }

    static ReloadPrescriptions = (e) => {
      const currentRxProductPage = document.querySelector(
          '.prescription-details-modal.open'
      ) as HTMLElement;

      if(currentRxProductPage) {
        const purchaseButton = currentRxProductPage.querySelector<HTMLElement>(
          '[data-action="prescription-buy"]'
        );

        const ordinationId = purchaseButton.attributes['data-ordination-id']?.value;
        const proxySsn = purchaseButton.attributes['data-userId']?.value;
        const proxyFullName = purchaseButton.attributes['data-fullname']?.value;
        
        MyPrescriptions.LoadPrescriptionDetails(
            ordinationId,
            proxySsn,
            proxyFullName
        );
      }

      MyPrescriptions.LoadPrescriptions(true);
    };

    static CheckForPreSelectedUserInRequest = () => {
      const params = MyPrescriptions.DecodeUrlParams();
      const proxySsn = params.get('pid');
      const isAnimal = params.get('animal');

      if (
        MyPrescriptions.proxyListElement &&
        MyPrescriptions.proxyListElement.attributes['data-loaded']?.value === 'false'
      ) {
        if (isAnimal) {
          MyPrescriptions.LoadProxyData(false, null, true);
        } else if (proxySsn) {
          MyPrescriptions.LoadProxyData(false, proxySsn, false);
        } else {
          MyPrescriptions.LoadProxyData(true, null, false);
        }
      }
    };

    static LoadProxyData = (
      selectCurrentLoggedinUser?: boolean,
      preSelectProxyId?: string,
      preSelectAnimals?: boolean
    ) => {
      MyPrescriptions.proxyListElement.innerHTML = MyPrescriptions.loaderString;

      if (selectCurrentLoggedinUser) {
        MyPrescriptions.LoadPrescriptions(true);
      }

      prescriptionService
        .GetProxies()
        .then((response) => {
          if (response.status !== 200 || !response.data.success) {
            MyPrescriptions.proxyListElement.innerHTML = '';
            return;
          }

          if (!MyPrescriptions.proxyListElement) {
            return;
          }

          MyPrescriptions.proxyListElement.innerHTML = response.data.proxyListPartial;
          MyPrescriptions.proxyListElement.setAttribute('data-loaded', 'true');

          if (preSelectProxyId) {
            const selectableProxyElement = getElement<HTMLElement>(`[data-proxy-id="${preSelectProxyId}"]`);
            MyPrescriptions.ChangeSelectedProxy(null, selectableProxyElement);
            return;
          }

          if (preSelectAnimals) {
            const selectableProxyElement = getElement<HTMLElement>('[data-animals-proxy="true"]');
            if (selectableProxyElement) {
              MyPrescriptions.ChangeSelectedProxy(null, selectableProxyElement);
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    };

    static LoadPrescriptions = async (
      ignoreSelectedProxyElement: boolean,
      sortKey?: string,
      sortDirection?: string
    ) => {
      const selectedProxyElem = getElement<HTMLElement>('[data-container="selected-proxy"]');

      if (
        (!ignoreSelectedProxyElement && !selectedProxyElem) ||
        !MyPrescriptions.prescriptionListElement
      ) {
        return;
      }

      MyPrescriptions.prescriptionListElement.innerHTML =
        MyPrescriptions.loaderString;

      MyPrescriptions.proxyListElement.setAttribute('data-state', 'closed');

      const isAnimalRequest =
        selectedProxyElem &&
        selectedProxyElem.attributes['data-is-animal']?.value === 'true';

      if (sortKey && sortDirection) {
        if (isAnimalRequest) {
          MyPrescriptions.LoadSortedPrescriptionsListAnimal(sortKey, sortDirection);
          return;
        }
        return MyPrescriptions.LoadSortedPrescriptionsListHuman(sortKey, sortDirection);
      }

      if (isAnimalRequest) {
        MyPrescriptions.LoadPrescriptionsPageAnimal();
        return;
      }

      return MyPrescriptions.LoadPrescriptionsPageHuman();
    };

    static ChangeProxySelectorState = (
      e?: PointerEvent | MouseEvent | null
    ): void => {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      try {
        const currentState = MyPrescriptions.proxyListElement.attributes['data-state']?.value;
        const newState = currentState === 'open' ? 'closed' : 'open';

        MyPrescriptions.proxyListElement.setAttribute('data-state', newState);
        const icon = getElement<HTMLElement>('.right .icon', MyPrescriptions.proxyListElement);

        if (icon) {
          if (newState === 'open') {
            removeCss(icon, 'icon-caret-down');
            addCss(icon, 'icon-caret-up');
          } else {
            removeCss(icon, 'icon-caret-up');
            addCss(icon, 'icon-caret-down');
          }
        }
      }
      catch (error) {
        console.log(error);
      }
    };

    static CloseProxyList = (e: PointerEvent | MouseEvent): void => {
      try {
        if (
          e.target instanceof Node &&
          MyPrescriptions.proxyListElement.contains(e.target)
        ) {
          MyPrescriptions.proxyListElement.setAttribute('data-state', 'open');
          MyPrescriptions.ChangeProxySelectorState(null);
        }
      }
      catch (error) {
        console.log(error);
      }
    };

    static SelectProxyPerson = (e?: Event): void => {
      try {
        const select = e.target as HTMLSelectElement;
        const selectedValue = select.value;
        const proxyElement = getElement<HTMLElement>(`[data-proxy-id="${selectedValue}"]`);

        if (proxyElement) {
          MyPrescriptions.ChangeSelectedProxy(null, proxyElement);
        }
      }
      catch (error) {
        console.log(error);
      }
    };

    static ChangeSelectedProxy = (e?, selectElement?: HTMLElement): void => {
      let proxyElement: HTMLElement;

      // 1. Determine the source element that represents the proxy (either from an event or a direct element)
      if (e) {
        e.preventDefault();
        e.stopPropagation();
        proxyElement = e.target.closest('[data-proxy]') as HTMLElement;
      } else if (selectElement) {
        proxyElement = selectElement;
      }

      // 2. If no valid proxy element found, exit the function
      if (!proxyElement) {
        return;
      }

      // 3. Extract custom data attributes from the selected proxy element
      const proxy = proxyElement as HTMLElement;
      const isAnimalProxy = proxy.dataset.animalsProxy === 'true';
      const newSsn = proxy.dataset.proxyId;
      const newName = proxy.dataset.name;
      const newIsChild = proxy.dataset.child;
      const ssnAsText = proxy.dataset.ssnText;
      const iconStyle = proxy.dataset.icon;

      // 4. Find the container element that displays the currently selected proxy
      const selectedProxyElem = getElement<HTMLElement>('[data-container="selected-proxy"]');

      // 5. Update proxy-related data attributes on the container
      selectedProxyElem.dataset.isAnimal = isAnimalProxy.toString();
      selectedProxyElem.dataset.selectedId = newSsn ?? '';
      selectedProxyElem.dataset.name = newName ?? '';
      selectedProxyElem.dataset.child = newIsChild ?? '';

      // 5.1. Update the native select element (for accessibility sync)
      const selectElem = getElement<HTMLSelectElement>('#select-proxy-person');
      if (selectElem && newSsn && selectElem.value !== newSsn) {
        selectElem.value = newSsn;
      }

      // 6. Update visible text in the UI to reflect the new proxy
      if (isAnimalProxy) {
        selectedProxyElem.querySelector('.selected-proxy-display').innerHTML = proxyElement.dataset.displayText;
      } else {
        selectedProxyElem.querySelector('.selected-proxy-display').innerHTML = `${newName}, ${ssnAsText}`;
      }

      // 7. Update the icon shown for the proxy (e.g. person vs animal)
      removeCss(selectedProxyElem.querySelector('i'), ['icon-paw', 'icon-person']);
      addCss(selectedProxyElem.querySelector('i'), iconStyle);

      // 8. Trigger downstream changes (probably update UI and data)
      MyPrescriptions.ChangeProxySelectorState(null);
      MyPrescriptions.LoadPrescriptions(false);
    };

    static CheckBrowserNavigation = () => {
      const params = MyPrescriptions.DecodeUrlParams();
      const prescriptionId = params.get('details');
      const recipeRowId = params.get('recipeRowId');
      const proxySsn = params.get('pid');
      const isAnimal = params.get('animal');
      const fullName = params.get('name');

      if (prescriptionId) {
        if (isAnimal) {
          MyPrescriptions.OpenAnimalPrescriptionDetails(
            null,
            prescriptionId,
            recipeRowId
          );
        } else {
          MyPrescriptions.OpenPrescriptionDetails(
            null,
            prescriptionId,
            proxySsn,
            fullName
          );
        }
      } else if (
        MyPrescriptions.prescriptionDetailsModal?.classList.contains('open')
      ) {
        MyPrescriptions.ClosePrescriptionDetails(null);
      }
    };

    static AddBrowserHistoryEntry = (
      ordinationId: string,
      proxySsn: string,
      fullName: string
    ) => {
      const url = new URL(window.location.href);
      const base64String: string = window.btoa(`?details=${ordinationId}&pid=${proxySsn}&name=${fullName}`);
      url.searchParams.set('q', base64String);
      window.history.pushState({}, '', url.toString());
    };

    static OpenPrescriptionDetails = (
      e: any,
      id: string,
      pid: string,
      name: string
    ) => {
      // Check if this is a keydown event and if it's not Enter or Space, ignore it.
      if (e instanceof KeyboardEvent && e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
        return;
      }

      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }

      MyPrescriptions.OpenDetailsModal();

      let ordinationId = id || null;
      let proxySsn = pid || null;
      let fullName = name || null;

      // Store the ordination-id of the ordination clicked.
      MyPrescriptions.lastOrdinationId = document.activeElement.getAttribute('data-prescription-ordinationid');

      if (e) {
        const prescriptionElement: HTMLElement = e.target.closest(
          '[data-action="prescription-details"]'
        ) as HTMLElement;
        ordinationId =
          id ||
          prescriptionElement.attributes['data-prescription-ordinationId']
            ?.value;
        const selectedProxyElem = getElement<HTMLElement>('[data-container="selected-proxy"]');
        proxySsn =
          pid || selectedProxyElem.attributes['data-selected-id']?.value;
        fullName = name || selectedProxyElem.attributes['data-name']?.value;
      }

      if (!ordinationId || !proxySsn) {
        MyPrescriptions.prescriptionDetailsContainer.innerHTML = '';
        return;
      }

      MyPrescriptions.AddBrowserHistoryEntry(ordinationId, proxySsn, fullName);
      window.scrollTo(0, 0);

      if (!e) {
        MyPrescriptions.LoadPrescriptionDetails(
          ordinationId,
          proxySsn,
          fullName
        );
        return;
      }

      const detailsElement = e.target.querySelector('.details');
      if (!detailsElement) {
        MyPrescriptions.prescriptionDetailsContainer.innerHTML = '';
        return;
      }

      MyPrescriptions.prescriptionDetailsContainer.innerHTML = detailsElement.innerHTML;

      // Set the focus when opening a prescription details modal.
      const focusElement = getElement<HTMLButtonElement>('button[data-action="close-prescription-details"]');
      focusElement?.focus();
    };

    static LoadPrescriptionDetails = (
      ordinationId: string,
      proxySsn: string,
      fullName: string
    ) => {
      const requestData: prescriptionService.PrescriptionDetailsRequest = {
        ordinationId: Number.parseInt(ordinationId, 10),
        selectedUserSsn: proxySsn,
        fullName
      };

      prescriptionService
        .GetPrescriptionDetails(requestData)
        .then((response) => {
          if (
            response.status === 200 &&
            response.data != null &&
            response.data.success
          ) {
            MyPrescriptions.prescriptionDetailsContainer.innerHTML = response.data.prescriptionDetailsPartial;
          } else {
            MyPrescriptions.prescriptionDetailsContainer.innerHTML = '';
          }

          basket.Basket.getBasket();
        })
        .catch((error) => {
          MyPrescriptions.prescriptionDetailsContainer.innerHTML = '';
          console.log(error);
        });
    };

    static OpenAnimalPrescriptionDetails = (e, id: string, rowId: string) => {
      // Check if this is a keydown event and if it's not Enter or Space, ignore it
      if (e instanceof KeyboardEvent && e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
        return;
      }

      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      
      MyPrescriptions.OpenDetailsModal();

      let prescriptionId = id || null;
      let prescriptionRowId = rowId || null;

      if (e) {
        const prescriptionElement: HTMLElement = e.target.closest(
          '[data-action="animal-prescription-details"]'
        ) as HTMLElement;
        prescriptionId =
          id || prescriptionElement.attributes['data-prescription-id']?.value;
        prescriptionRowId =
          rowId || prescriptionElement.attributes['data-recipe-row-id']?.value;
      }

      if (prescriptionId && prescriptionRowId) {
        const url = new URL(window.location.href);
        const base64String = window.btoa(
          `?details=${prescriptionId}&recipeRowId=${prescriptionRowId}&animal=true`
        );
        url.searchParams.set('q', base64String);
        window.history.pushState({}, '', url.toString());

        window.scrollTo(0, 0);

        if (!e) {
          MyPrescriptions.LoadAnimalPrescriptionDetails(id, prescriptionRowId);
          return;
        }

        const detailsElement = e.target.querySelector('.details');
        if (!detailsElement) {
          MyPrescriptions.prescriptionDetailsContainer.innerHTML = '';
          return;
        }

        MyPrescriptions.prescriptionDetailsContainer.innerHTML =
          detailsElement.innerHTML;
      } else {
        MyPrescriptions.prescriptionDetailsContainer.innerHTML = '';
      }
    };

    static LoadAnimalPrescriptionDetails = (
      prescriptionId: string,
      recipeRowId: string
    ) => {
      const requestData: prescriptionService.AnimalPrescriptionDetailsRequest =
      {
        prescriptionId,
        recipeRowId
      };

      prescriptionService
        .GetAnimalPrescriptionDetails(requestData)
        .then((response) => {
          if (
            response.status === 200 &&
            response.data != null &&
            response.data.success
          ) {
            MyPrescriptions.prescriptionDetailsContainer.innerHTML =
              response.data.prescriptionDetailsPartial;
          } else {
            MyPrescriptions.prescriptionDetailsContainer.innerHTML = '';
          }
          basket.Basket.getBasket();
        })
        .catch((error) => {
          MyPrescriptions.prescriptionDetailsContainer.innerHTML = '';
          console.log(error);
        });
    };

    static ClosePrescriptionDetails = (e) => {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      
      addCss(MyPrescriptions.prescriptionDetailsModal, 'closed');
      removeCss(MyPrescriptions.prescriptionDetailsModal, 'open');
      MyPrescriptions.prescriptionDetailsContainer.innerHTML = '';
      removeCss(document.querySelector('[data-container="prescription-page"]'), 'hidden');
      removeCss(document.querySelector('[data-prescription-banner]'), 'hidden');
      removeCss(document.querySelector('[data-container="prescription-bottom"]'), 'hidden');

      window.scroll({
        left: 0,
        top: MyPrescriptions.Instance.scrollState,
        behavior: 'auto'
      });

      const lastOrdination = getElement<HTMLElement>(`[data-prescription-ordinationid="${MyPrescriptions.lastOrdinationId}"]`);
      if (lastOrdination) {
        lastOrdination.focus();
      }

      const url = new URL(window.location.href);
      url.searchParams.delete('q');
      window.history.pushState({}, '', url.toString());
      window.dispatchEvent(new Event('popstate'));
    };

    static PrescriptionBuy = (e) => {
      let button = e.target as HTMLButtonElement;

      if (button && button.tagName !== 'BUTTON') {
        button = button.parentNode as HTMLButtonElement;
      }

      if (
        !button ||
        button.disabled ||
        button.hasAttribute('data-disabled') ||
        button.tagName !== 'BUTTON'
      ) {
        return;
      }

      button.setAttribute('data-disabled', 'true');

      const currentButtonText = button.innerHTML;
      button.innerHTML = MyPrescriptions.buttonLoaderString;

      const isAnimalPrescription: boolean = parseToBoolean(
        button.attributes['data-animal']?.value ?? false
      );

      const postData: prescriptionService.PrescriptionBuyCommand =
        MyPrescriptions.CreateBuyCommand(button);

      const token: string = button.attributes['data-token']?.value;

      prescriptionService
        .PostPrescriptionBuy(postData, token)
        .then((response) => {
          if (response.data?.message) {
            MyPrescriptions.displayMessage(e, response.data);
          }

          if (response.status !== 200 || response.data == null) {
            return;
          }

          if (!response.data.success) {
            button.innerHTML = currentButtonText;
            button.removeAttribute('data-disabled');
            return;
          }

          if (isAnimalPrescription) {
            MyPrescriptions.LoadAnimalPrescriptionDetails(
              postData.ordinationId,
              postData.receptRadId
            );
          } else {
            basket.Basket.getBasket();
          }
          MyPrescriptions.ClosePrescriptionDetails(null);
          // Load and display the prescription list
          return MyPrescriptions.LoadPrescriptions(false);
        })
        .then(() => {
          const humanPrescriptionSelector = `[data-prescription-ordinationid="${postData.ordinationId}"]`;
          const animalPrescriptionSelector = `[data-prescription-id="${postData.ordinationId}"]`;

          let purchasedPrescriptionElement = getElement<HTMLElement>(humanPrescriptionSelector);
          if (!purchasedPrescriptionElement) {
            purchasedPrescriptionElement = getElement<HTMLElement>(animalPrescriptionSelector);
          }

          if (!purchasedPrescriptionElement) {
            return;
          }

          const purchasedPrescriptionCard = purchasedPrescriptionElement.closest('.prescription-card') as HTMLElement;
          MyPrescriptions.scrollToElement(purchasedPrescriptionCard);
        })
        .catch((error) => {
          console.log(error);
        });
    };

    static displayMessage = (e, data) => {
      const targetElement: HTMLElement = e.target as HTMLElement;

      /* Default is error/fail. */
      let messageSeverity: MessageSeverity = MessageSeverity.error;
      let elementState = State.Fail;

      if (data.success === true) {
        messageSeverity = MessageSeverity.success;
        elementState = State.Success;
      }

      EasyfyToaster.toaster(messageSeverity, data.message);
      targetElement.dataset.state = elementState;
    };

    static TogglePrescriptionInfo = (e) => {
      e.preventDefault();
      e.stopPropagation();

      const link = e.target as HTMLElement;
      if (!link) return;

      const id = link.attributes['data-target']?.value;
      if (!id) return;

      const toggleMe = getElement<HTMLElement>(`[data-prescription-extra="${id}"]`);
      const openLink = getElement<HTMLElement>(`[data-open="${id}"]`);
      if (!toggleMe || !openLink) return;
      hasClass(toggleMe, 'hidden')
        ? removeCss(toggleMe, 'hidden')
        : addCss(toggleMe, 'hidden');
      hasClass(openLink, 'hidden')
        ? removeCss(openLink, 'hidden')
        : addCss(openLink, 'hidden');
    };

    static GetChildModal = (_e: Event) => {
      const addToElement = getElement<HTMLElement>('[data-container="prescription-page"]');
      if (addToElement) {
        MyPrescriptions.Instance.modal.OnClose = (success, data) => {
          if (success) {
            EasyfyToaster.toaster(MessageSeverity.success, 'Barn tillagt', null, 20000);
            if (data?.ssn) {
              MyPrescriptions.LoadProxyData(false, data.ssn, false);
            }
          }
        };
        MyPrescriptions.Instance.modal.AppendModal(
          ModalType.AddChildProxy,
          addToElement
        );
      }
    };

    private static ChangeSort = (e: Event) => {
      e.preventDefault();
      e.stopPropagation();

      const input: HTMLSelectElement = e.target as HTMLSelectElement;
      const selectedValue = input.value;
      const sortKey = selectedValue.split('-')[0];
      const direction = selectedValue.split('-')[1];
      const container = input.closest('[data-container="custom-select"]');

      if (container) {
        container.querySelector('.select-item.selected')?.classList.remove('selected');
        container.querySelector(`.select-item[data-value="${selectedValue}"]`)?.classList.add('selected');
      }

      MyPrescriptions.LoadPrescriptions(true, sortKey, direction);
    };

    static GetAnimalConsentModal = (_e: Event) => {
      const addToElement = getElement<HTMLElement>('[data-container="prescription-page"]');
      if (addToElement) {
        MyPrescriptions.Instance.modal.OnClose = (success) => {
          if (success) {
            MyPrescriptions.LoadProxyData(false, null, true);
          }
        };
        MyPrescriptions.Instance.modal.AppendModal(
          ModalType.GiveAnimalConsent,
          addToElement
        );
      }
    };

    static CloseMessage = () => {
      removeCss(MyPrescriptions.messageArea, ['success', 'warning', 'error']);
      MyPrescriptions.messageArea.querySelector('.message').innerHTML = '';
    };

    static GetFassModal = (e) => {
      e.preventDefault();
      e.stopPropagation();
      const addToElement = getElement<HTMLElement>('body');
      const headerParam = (e.target as HTMLElement).attributes[
        'data-modal-header'
      ]?.value;
      const isAnimal =
        (e.target as HTMLElement).attributes['data-is-animal']?.value ?? false;
      const isNplPackId =
        (e.target as HTMLElement).attributes['data-is-nplpackid']?.value ??
        false;
      const id =
        (e.target as HTMLElement).attributes['data-fass-id']?.value ?? false;
      if (addToElement) {
        const data = {
          header: headerParam || 'FASS',
          id,
          isNplPackId,
          isAnimal
        };
        MyPrescriptions.Instance.modal.AppendModal(
          ModalType.FassDocument,
          addToElement,
          data
        );
      }
    };

    static GetExchangeInfoModal = (e) => {
      e.preventDefault();
      e.stopPropagation();
      const addToElement = getElement<HTMLElement>('[data-container="prescription-details-modal"]');
      if (addToElement) {
        MyPrescriptions.Instance.modal.AppendModal(
          ModalType.ExchangeInfoModal,
          addToElement
        );
      }
    };

    static LoadPrescriptionsPageAnimal = () => {
      MyPrescriptions.subventionsElement.innerHTML = '';
      MyPrescriptions.expiredPrescriptionsElement.innerHTML = '';
      MyPrescriptions.prescriptionListSortersElement.innerHTML = MyPrescriptions.loaderString;
      // prevent multi-requests to get to client, only display latest requested data
      MyPrescriptions.Instance.selectedProxy = 'animals';

      const requestData: prescriptionService.AnimalPrescriptionListRequest = {
        sortDirection: prescriptionService.SortDirection.Descending,
        sortKey: prescriptionService.PrescriptionListSortOptions.Date
      };

      // Animal prescriptions
      prescriptionService
        .GetAnimalPrescriptionList(requestData)
        .then((response) => {
          if (
            response.status !== 200 ||
            response.data == null ||
            !response.data.success
          ) {
            MyPrescriptions.prescriptionListElement.innerHTML = '';
            return;
          }

          if (
            response.data.requestFor === MyPrescriptions.Instance.selectedProxy
          ) {
            MyPrescriptions.prescriptionListElement.innerHTML =
              response.data.prescriptionListPartial;
            MyPrescriptions.prescriptionListSortersElement.innerHTML =
              response.data.sortPartial;
          }
        })
        .catch((error) => {
          MyPrescriptions.prescriptionListElement.innerHTML = '';
          console.log(error);
        });
    };

    static LoadSortedPrescriptionsListHuman = async (sortKey: string, sortDirection: string) => {
      const { proxySsn, proxyName, proxyIsChild, token } = MyPrescriptions.GetSelectedProxyData();

      const requestData: prescriptionService.PrescriptionRequest = {
        selectedUserSsn: proxySsn,
        proxyPersonName: proxyName,
        isChild: proxyIsChild,
        sortDirection: prescriptionService.parseSortDirection(sortDirection),
        sortKey: prescriptionService.parseSortOption(sortKey)
      };

      // prevent multi-requests to get to client, only display latest requested data
      MyPrescriptions.Instance.selectedProxy = proxySsn;

      // Fetch prescriptions
      const response = await prescriptionService.GetPrescriptionList(
        requestData,
        token
      );
      if (
        response.status !== 200 ||
        response.data == null ||
        !response.data.success
      ) {
        MyPrescriptions.prescriptionListElement.innerHTML = '';
        return;
      }

      // In case no proxy has been selected, assume the one we have requested should be displayed
      if (!MyPrescriptions.Instance.selectedProxy) {
        MyPrescriptions.Instance.selectedProxy = response.data.requestFor;
      }

      if (response.data.requestFor === MyPrescriptions.Instance.selectedProxy) {
        MyPrescriptions.prescriptionListElement.innerHTML =
          response.data.prescriptionListPartial;
      }

      return response;
    };

    static LoadSortedPrescriptionsListAnimal = (sortKey: string, sortDirection: string) => {
      MyPrescriptions.Instance.selectedProxy = 'animals';

      const requestData: prescriptionService.AnimalPrescriptionListRequest = {
        sortDirection: prescriptionService.parseSortDirection(sortDirection),
        sortKey: prescriptionService.parseSortOption(sortKey)
      };

      prescriptionService
        .GetAnimalPrescriptionList(requestData)
        .then((response) => {
          if (
            response.status !== 200 ||
            response.data == null ||
            !response.data.success
          ) {
            MyPrescriptions.prescriptionListElement.innerHTML = '';
            return;
          }

          if (
            response.data.requestFor === MyPrescriptions.Instance.selectedProxy
          ) {
            MyPrescriptions.prescriptionListElement.innerHTML =
              response.data.prescriptionListPartial;
            MyPrescriptions.prescriptionListSortersElement.innerHTML =
              response.data.sortPartial;
          }
        })
        .catch((error) => {
          MyPrescriptions.prescriptionListElement.innerHTML = '';
          console.log(error);
        });
    };

    static LoadPrescriptionsPageHuman = async () => {
      MyPrescriptions.subventionsElement.innerHTML = MyPrescriptions.loaderString;
      MyPrescriptions.expiredPrescriptionsElement.innerHTML = MyPrescriptions.loaderString;
      MyPrescriptions.prescriptionListSortersElement.innerHTML = MyPrescriptions.loaderString;

      const { proxySsn, proxyName, proxyIsChild, token } = MyPrescriptions.GetSelectedProxyData();

      const subventionDetailsRequest: prescriptionService.SubventionDetailsRequest = {
        selectedUserSsn: proxySsn,
        proxyPersonName: proxyName,
        displayHeader: true
      };

      // Fetch subventions
      prescriptionService
        .GetSubventionDetails(subventionDetailsRequest, token)
        .then((response) => {
          if (
            response.status !== 200 ||
            response.data == null ||
            !response.data.success
          ) {
            MyPrescriptions.subventionsElement.innerHTML = '';
            return;
          }

          MyPrescriptions.subventionsElement.innerHTML =
            response.data.subventionDetailsPartial;
        })
        .catch((error) => {
          MyPrescriptions.subventionsElement.innerHTML = '';
          console.log(error);
        });

      const requestData: prescriptionService.PrescriptionRequest = {
        selectedUserSsn: proxySsn,
        proxyPersonName: proxyName,
        isChild: proxyIsChild,
        sortDirection: prescriptionService.SortDirection.Descending,
        sortKey: prescriptionService.PrescriptionListSortOptions.Date
      };

      // Fetch expired prescriptions
      prescriptionService
        .GetExpiredPrescriptionsList(requestData, token)
        .then((response) => {
          if (
            response.status !== 200 ||
            response.data == null ||
            !response.data.success
          ) {
            MyPrescriptions.expiredPrescriptionsElement.innerHTML = '';
            return;
          }

          MyPrescriptions.expiredPrescriptionsElement.innerHTML =
            response.data.expiredPrescriptionListPartial;
        })
        .catch((error) => {
          MyPrescriptions.expiredPrescriptionsElement.innerHTML = '';
          console.log(error);
        });

      // prevent multi-requests to get to client, only display latest requested data
      MyPrescriptions.Instance.selectedProxy = proxySsn;

      // Fetch prescriptions
      const response = await prescriptionService.GetPrescriptionList(
        requestData,
        token
      );
      if (
        response.status !== 200 ||
        response.data == null ||
        !response.data.success
      ) {
        MyPrescriptions.prescriptionListElement.innerHTML = '';
        return;
      }

      // In case no proxy has been selected, assume the one we have requested should be displayed
      if (!MyPrescriptions.Instance.selectedProxy) {
        MyPrescriptions.Instance.selectedProxy = response.data.requestFor;
      }

      if (response.data.requestFor === MyPrescriptions.Instance.selectedProxy) {
        MyPrescriptions.prescriptionListElement.innerHTML =
          response.data.prescriptionListPartial;
        MyPrescriptions.prescriptionListSortersElement.innerHTML =
          response.data.sortPartial;
      }

      return response;
    };

    static CreateBuyCommand = (
      button: HTMLButtonElement
    ): prescriptionService.PrescriptionBuyCommand => {
      let parsePrice = Number.parseFloat(
        button.attributes['data-price']?.value.replace(',', '.')
      );
      let parsePvPrice = Number.parseFloat(
        button.attributes['data-pv-price']?.value.replace(',', '.')
      );

      parsePrice = Number.isNaN(parsePrice) ? 0 : parsePrice;
      parsePvPrice = Number.isNaN(parsePvPrice) ? 0 : parsePvPrice;
      const ordinationId: string =
        button.attributes['data-ordination-id']?.value;
      const nplPackId: string = button.attributes['data-nplPackId']?.value;
      const price: Number = parsePrice;
      const prescriptionPurchasable: boolean = parseToBoolean(
        button.attributes['data-prescription-purchasable']?.value
      );
      const drugPurchasable: boolean = parseToBoolean(
        button.attributes['data-drug-purchasable']?.value
      );
      const pvPrice: Number = parsePvPrice;
      const quantity: Number = Number.parseInt(button.attributes['data-quantity']?.value, 10);
      const varuId: string = button.attributes['data-varuId']?.value;
      const receptRadId: string = button.attributes['data-receptRadId']?.value;
      const withBenefits: boolean = parseToBoolean(
        button.attributes['data-benefit']?.value
      );
      const hash: string = button.attributes['data-hash']?.value;
      const userId: string = button.attributes['data-userId']?.value;
      const fullName: string = button.attributes['data-fullname']?.value;

      return {
        ordinationId,
        nplPackId,
        price,
        prescriptionPurchasable,
        drugPurchasable,
        customPvPrice: pvPrice,
        quantity,
        varuNr: varuId,
        receptRadId,
        withBenefits,
        hash,
        userId,
        fullName
      };
    };

    private static DecodeUrlParams(): URLSearchParams {
      const url = new URL(window.location.href);
      const q = url.searchParams.get('q');
      try {
        url.search = q ? window.atob(q) : '';
      } catch {
        url.search = '';
      }
      return url.searchParams;
    }

    private static OpenDetailsModal(): void {
      MyPrescriptions.Instance.scrollState = window.scrollY;
      removeCss(MyPrescriptions.prescriptionDetailsModal, 'closed');
      addCss(MyPrescriptions.prescriptionDetailsModal, 'open');
      MyPrescriptions.prescriptionDetailsContainer.innerHTML = MyPrescriptions.loaderString;
      addCss(document.querySelector('[data-container="prescription-page"]'), 'hidden');
      addCss(document.querySelector('[data-prescription-banner]'), 'hidden');
      addCss(document.querySelector('[data-container="prescription-bottom"]'), 'hidden');
    }

    private static GetSelectedProxyData(): { proxySsn: string; proxyName: string; proxyIsChild: boolean; token: string } {
      const selectedProxyElem = getElement<HTMLElement>('[data-container="selected-proxy"]');
      const proxySsn = selectedProxyElem ? selectedProxyElem.attributes['data-selected-id']?.value : '';
      const proxyName = selectedProxyElem ? selectedProxyElem.attributes['data-name']?.value : '';
      const proxyIsChild = selectedProxyElem ? parseToBoolean(selectedProxyElem.attributes['data-child']?.value) : false;
      let token: string;
      if (selectedProxyElem) {
        token = selectedProxyElem.attributes['data-token']?.value;
      } else {
        const tokenElem = getElement<HTMLElement>('[data-token]');
        if (tokenElem) {
          token = tokenElem.dataset.token;
        }
      }
      return { proxySsn, proxyName, proxyIsChild, token };
    }

    private static scrollToElement(elem: HTMLElement) {
      const elementMargin = parseInt(window.getComputedStyle(elem).marginTop, 10) * 2;
      const elementOffset = elem.offsetTop - elementMargin;
      const headerHeight = getElement<HTMLElement>('header')?.offsetHeight ?? 0;
      setTimeout(() => {
        window.scroll({
          left: 0,
          top: elementOffset - (headerHeight + 20),
          behavior: 'smooth'
        });
      }, 100);

      const lastOrdination = getElement<HTMLElement>(`[data-prescription-ordinationid="${MyPrescriptions.lastOrdinationId}"]`);
      if (lastOrdination) {
        lastOrdination.focus();
      }
    }
  }

}

export default Easyfy.Web.Pages;
